module.exports = __webpack_public_path__ + "static/2019426:2ace0725733a716000c6/img/handsome_3x.bb3d215.png";


//////////////////
// WEBPACK FOOTER
// ./app/src/assets/images/home/handsome_3x.png
// module id = cVHG
// module chunks = 41